module.exports = {
　  language: {
　　　　name: 'English'
　　},
　　navbar: {
　　　　home: '主页',
        walkInto:'走进探见',
        coreBusiness:'核心业务',
        case:'案例欣赏',
        news:'新闻中心',
        link:'联系我们'
　　},
    home:{
        companyNews:'公司新闻',
        industryNews:'行业新闻',
        more:'更多'

    }
}